import { Button } from "~/atoms/button";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import DOMPurify from "dompurify";
import { useElementOverflow } from "~/hooks/useElementOverflow";
import { cn } from "~/lib/utils";

interface Props {
  html: string;
  expand?: boolean;
}

export function ClampHtml({ html, expand = false }: Props) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(expand);
  const [prevExpand, setPrevExpand] = useState(expand);
  const { ref: contentRef, isOverflowing: isClamped } =
    useElementOverflow<HTMLDivElement>();
  const sanitizedHtml = useMemo(() => DOMPurify.sanitize(html), [html]);

  if (prevExpand !== expand) {
    setPrevExpand(expand);
    setExpanded(expand);
  }

  return (
    <>
      <div
        ref={contentRef}
        className={cn("font-sans text-sm", { "line-clamp-3": !expanded })}
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      />

      <div className="flex justify-center" hidden={!isClamped && !expanded}>
        <Button variant="link" onClick={() => setExpanded(!expanded)}>
          {expanded
            ? t(($) => $.commons.buttons.collapse)
            : t(($) => $.commons.buttons.expand)}
        </Button>
      </div>
    </>
  );
}
